import axios from 'src/utils/axios';
import { API_BASE_URL } from 'src/config';

export const GET_BRANCH_TYPES = '@branch-types/get-branch-types';
export const REQUEST_BRANCH_TYPES = '@branch-types/request-branch-types';
export const SET_BRANCH_TYPES = '@branch-types/set-branch-types';

export function getBranchTypes(page = 1, pagesize = 10, orderby = 'name', orderdirection = 'asc') {
  const params = {
    page,
    orderby,
    orderdirection
  };

  if (pagesize > 0) {
    params.pagesize = pagesize;
  }

  const request = axios.get(`${API_BASE_URL}/branch/type`, { params });

  return (dispatch) => {
    dispatch({ type: REQUEST_BRANCH_TYPES });

    request
      .then((response) =>
        dispatch({
          type: GET_BRANCH_TYPES,
          payload: { branchTypes: response.data, total: response.data.length }
        })
      )
      .catch((error) => {
        let message = '';
        if (error.response) {
          message = error.response.data;
        }
        dispatch({
          type: GET_BRANCH_TYPES,
          payload: { branchTypes: [], total: 0, message }
        });
      });
  };
}

export function setBranches(branches) {
  return (dispatch) => {
    dispatch({
      type: SET_BRANCH_TYPES,
      payload: { branches }
    });
  };
}
